import { DataBean } from "../DataBean";

export class AssignExternal extends DataBean {



    public async assignExternalFactoryToProductionOrder(idProductionOrder: any, productionOrderDate: any, idExternalFactory: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_assignExternalFactoryToProductionOrder_Number_java.util.Date_Number", [idProductionOrder, productionOrderDate, idExternalFactory]);
    }

}